export const RESERVED_SLUGS = [
  // 🌐 Public & Core Platform Routes
  "home",
  "index",
  "about",
  "contact",
  "help",
  "faq",
  "support",
  "login",
  "logout",
  "signup",
  "register",
  "dashboard",
  "auth",
  "verify",
  "forgot",
  "reset",
  "password",
  "profile",
  "settings",
  "account",
  "bookings",
  "vehicles",
  "checkout",
  "payment",
  "cart",
  "order",
  "confirm",
  "success",
  "cancel",
  "terms",
  "privacy",
  "legal",
  "search",
  "results",
  "notifications",
  "messages",
  "notifications",

  // 🛠️ Admin/Internal
  "admin",
  "superadmin",
  "mod",
  "moderator",
  "backend",
  "internal",
  "root",
  "system",
  "api",
  "service-worker",
  "manifest",
  "robots",
  "security",
  "metrics",
  "db",
  "database",

  // 💼 Marketing or Future Routes
  "blog",
  "news",
  "press",
  "articles",
  "insights",
  "explore",
  "discover",
  "deals",
  "rewards",
  "offers",
  "promo",
  "referral",
  "affiliates",
  "partners",
  "team",
  "careers",
  "jobs",
  "pricing",
  "compare",
  "features",

  // 🏝️ Major Cities/Locations in the Philippines
  "manila",
  "cebu",
  "davao",
  "siargao",
  "el-nido",
  "coron",
  "bohol",
  "panglao",
  "dumaguete",
  "iloilo",
  "bacolod",
  "tagaytay",
  "vigan",
  "la-union",
  "bataan",
  "palawan",
  "boracay",
  "zambales",
  "baler",
  "camiguin",
  "leyte",
  "samar",
  "mindoro",
  "antipolo",
  "batangas",
  "quezon",
  "rizal",
  "albay",
  "bicol",
  "naga",

  // 🧾 Location + keyword variants (protect SEO potential)
  "siargao-rentals",
  "siargao-motorbike",
  "siargao-bike",
  "siargao-bikes",
  "siargao-scooters",
  "el-nido-rentals",
  "el-nido-motorbike",
  "el-nido-bikes",
  "el-nido-scooters",
  "manila-rentals",
  "manila-motorbikes",
  "manila-bikes",
  "manila-scooters",
  "cebu-rentals",
  "cebu-motorbike",
  "cebu-bikes",
  "cebu-scooters",
  "davao-rentals",
  "davao-motorbikes",
  "davao-bikes",
  "davao-scooters",
  "palawan-rentals",
  "palawan-motorbikes",
  "palawan-bikes",
  "palawan-scooters",
  "bohol-rentals",
  "bohol-motorbikes",
  "bohol-bikes",
  "bohol-scooters",
  "panglao-rentals",
  "panglao-motorbikes",
  "panglao-bikes",
  "panglao-scooters",
  "iloilo-rentals",
  "iloilo-motorbike",
  "iloilo-bikes",
  "iloilo-scooters",
  "bacolod-rentals",
  "bacolod-motorbike",
  "bacolod-bikes",
  "bacolod-scooters",
  "la-union-rentals",
  "la-union-motorbike",
  "la-union-bikes",
  "la-union-scooters",
  "vigan-rentals",
  "vigan-motorbike",
  "vigan-bikes",
  "vigan-scooters",
  "bataan-rentals",
  "bataan-motorbike",
  "bataan-bikes",
  "bataan-scooters",
  "boracay-rentals",
  "boracay-motorbikes",
  "boracay-bikes",
  "boracay-scooters",
  "baler-rentals",
  "baler-motorbikes",
  "baler-bikes",
  "baler-scooters",
  "zambales-rentals",
  "zambales-motorbikes",
  "zambales-bikes",
  "zambales-scooters",
  "tagaytay-rentals",
  "tagaytay-motorbikes",
  "tagaytay-bikes",
  "tagaytay-scooters",
  "antipolo-rentals",
  "antipolo-motorbike",
  "antipolo-bikes",
  "antipolo-scooters",
  "camiguin-rentals",
  "camiguin-motorbike",
  "camiguin-bikes",
  "camiguin-scooters",
  "leyte-rentals",
  "leyte-motorbike",
  "leyte-bikes",
  "leyte-scooters",
  "samar-rentals",
  "samar-motorbike",
  "samar-bikes",
  "samar-scooters",
  "mindoro-rentals",
  "mindoro-motorbike",
  "mindoro-bikes",
  "mindoro-scooters",
  "bicol-rentals",
  "bicol-motorbike",
  "bicol-bikes",
  "bicol-scooters",
  "naga-rentals",
  "naga-motorbike",
  "naga-bikes",
  "naga-scooters",
  "albay-rentals",
  "albay-motorbike",
  "albay-bikes",
  "albay-scooters",

  // ⚠️ Generic / Brand / SEO-sensitive Terms
  "ridecan",
  "ride-can",
  "rentals",
  "motorbike",
  "motorbikes",
  "bike",
  "bikes",
  "scooter",
  "scooters",
  "shop",
  "shops",
  "listing",
  "listings",
  "review",
  "reviews",
  "compare",
  "location",
  "service",
  "services",
  "book",
  "booking",
  "rent",
  "rental",
  "vehicle",
  "vehicles",
  "app",
  "store",
  "web",
  "site",
  "website",
  "api",
  "mobile",
  "trip",
  "travel",
  "journey",
  "philippines",
  "asia",
  "pinoy",
  "filipino",

  // ❌ Tech / Reserved Terms
  "test",
  "staging",
  "dev",
  "development",
  "undefined",
  "null",
  "true",
  "false",
  "0",
  "1",
  "404",
  "500",
  "offline",
  "online",
  "new",
  "old",
  "latest",

  // 🚫 Inappropriate / Profanity
  "fuck",
  "shit",
  "sex",
  "xxx",
  "porn",
  "hentai",
  "nude",
  "naked",
  "bitch",
  "ass",
  "dick",
  "pussy",
  "whore",
  "slut",
  "cunt",
  "kill",
  "murder",
  "rape",
  "nsfw",

  // 🚫 Social Impersonation / Confusion
  "facebook",
  "instagram",
  "twitter",
  "x",
  "linkedin",
  "google",
  "youtube",
  "tiktok",
  "meta",
  "openai",
  "chatgpt",
  "gpt",
  "ai",
  "apple",
  "android",
  "windows",
  "microsoft",
  "chrome",
  "safari",
  "firefox",
  "mozilla",
];
